import {RANK_BACKGROUND_COLORS, RANK_NAME_COLORS} from '../../constants/factions';
import {FACTION_SKIN_DEFAULT_TYPE} from '../../constants/factions/skins';
import {
  ALL_FACTION_SKINS,
  getFactionSkinIconPath,
  getFactionSkinImagePath,
} from '../../configs/factions/skins/allFactionSkins';
import {getFactionIconPath} from './getFactionIconPath';
import {getFactionImagePath} from './getFactionImagePath';
import {getFactionRankImagePath} from './getFactionRankImagePath';
import {getFactionRankIconPath} from './getFactionRankIconPath';
import {resolveFactionColor} from './resolveFactionColor';
import {getFactionSkinAccentColorKey} from './getFactionSkinAccentColorKey';
import {getRankSkinLeague} from '../../configs/rankSkins';
import {getLeagueConfig} from '../../configs/leagues';

export function getFactionSkinDisplayProps(faction, selectedSkinId) {
  const factionId = faction?.id;
  if (!factionId) {
    return {
      type: FACTION_SKIN_DEFAULT_TYPE,
      imagePath: '',
      iconPath: '',
      textColor: '#fff',
      imageContainerStyle: undefined,
      skinName: null,
    };
  }

  const defaultSkinId = `${factionId}_default`;

  if (!selectedSkinId || selectedSkinId === defaultSkinId) {
    return {
      type: FACTION_SKIN_DEFAULT_TYPE,
      imagePath: getFactionImagePath(factionId),
      iconPath: getFactionIconPath(factionId),
      textColor: faction.textColor,
      imageContainerStyle: undefined,
      skinName: null,
    };
  }

  const rank = getRankSkinLeague(selectedSkinId);
  if (rank) {
    return {
      type: 'rank',
      rank,
      imagePath: getFactionRankImagePath(factionId, rank),
      iconPath: getFactionRankIconPath(factionId, rank),
      textColor: RANK_NAME_COLORS[rank],
      imageContainerStyle: {backgroundColor: RANK_BACKGROUND_COLORS[rank]},
      skinName: getLeagueConfig(rank)?.name || null,
    };
  }

  const skinConfig = ALL_FACTION_SKINS.find((skin) => skin.id === selectedSkinId);
  if (skinConfig && skinConfig.factionId === factionId) {
    const textColor = resolveFactionColor(
      getFactionSkinAccentColorKey(skinConfig, faction),
      faction.textColor
    );
    return {
      type: 'non-rank',
      imagePath: getFactionSkinImagePath(selectedSkinId),
      iconPath: getFactionSkinIconPath(selectedSkinId),
      textColor,
      imageContainerStyle: {backgroundColor: textColor},
      skinName: skinConfig.name,
    };
  }

  return {
    type: FACTION_SKIN_DEFAULT_TYPE,
    imagePath: getFactionImagePath(factionId),
    iconPath: getFactionIconPath(factionId),
    textColor: faction.textColor,
    imageContainerStyle: undefined,
    skinName: null,
  };
}
